<template>
	<div class="group2b_M">
		<template v-for="(item,index) in colarr">
			<report_unit v-if="indextype!=2||(indextype==2&&item.sub)">
					<ul class="item_title">
						<li class="L"><h1>{{item.name}}</h1></li>
						<li class="R"><a v-if="!item.sub" @click="selcol(item.id,item.name)" class="more3">更多</a></li>
					</ul>
					<ztindexitem v-if="!item.sub" :colid="item.id" :colname="item.name" :sourcecol="sourcecol"></ztindexitem>
					<template v-if="item.sub" v-for="(sitem,sindex) in item.sub">
						<ul class="title6">
							<li class="L">{{sitem.name}}</li>
							<li class="R"><a @click="selcol(sitem.id,sitem.name)" class="more3">更多</a></li>
						</ul>
						<ztindexitem :colid="sitem.id" :colname="sitem.name" :sourcecol="sourcecol"></ztindexitem>
					</template>
			</report_unit>
		</template>
	</div>
</template>

<script>
	import ztindexitem from '@/components/ztmyjj-index-item.vue'
	export default{
		components:{
			ztindexitem,
		},
		props:[
			'indextype',
			'sourcecol',
			'colarr'
		],
		methods:{
			selcol:function(selid,selname){
				this.$emit('changecol',selid,selname);
			}
		},
	}
</script>

<style>
</style>
